import React, { Fragment, useState, useCallback, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import { Row, Col, Card, CardBody, } from 'reactstrap';
import { tableColumns } from './DonationData';
import axios from 'axios';
import { ServerPath } from '../../Constant';
import Swal from 'sweetalert2';
import { Button } from 'react-bootstrap';
import { _axios } from '../../utils/axios';
import { Btn } from '../../AbstractElements';

const tableStyles = `
  .rdt_TableCell {
    padding: 4px 2px !important;
  }
  .rdt_TableHead {
    padding: 4px 2px !important;
  }
  .rdt_TableCol {
    padding: 4px 2px !important;
  }
  .rdt_TableCell[data-column-id="payment_status"] {
    position: sticky !important;
    right: 0;
    background-color: white !important;
     background-color: inherit !important;
    z-index: 1;
  }
  .rdt_TableHeadRow [data-column-id="payment_status"] {
    position: sticky !important;
    right: 0;
    background-color: white !important;
    z-index: 1;
  }
  .data-tables {
    overflow-x: auto;
    .badge-success {
      background-color: #E8FFF3 !important;
      color: #0BAF62 !important;
      border-radius: 16px !important;
      padding: 4px 12px !important;
      font-weight: 500 !important;
    }
    .badge-warning {
      background-color: #FFF8DD !important;
      color: #E8B600 !important;
      border-radius: 16px !important;
      padding: 4px 12px !important;
      font-weight: 500 !important;
    }
  }
`;

const DonationTable = ({ searchValue = '', selectedFilter = 'all', dateRange = null }) => {
    const [selectedRows, setSelectedRows] = useState([]);
    const [toggleDelete, setToggleDelete] = useState(false);
    const [data, setData] = useState([]);
    const [originalData, setOriginalData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10);

    // Apply filters when props change
    useEffect(() => {
        applyFiltersAndSearch(searchValue, selectedFilter, dateRange);
    }, [searchValue, selectedFilter, dateRange]);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handlePerRowsChange = (newPerPage, page) => {
        setPerPage(newPerPage);
        setCurrentPage(page);
    };

    const applyFiltersAndSearch = (searchValue, filterValue, dateValue) => {
        let filteredData = [...originalData];

        if (searchValue && searchValue.trim()) {
            const searchTerm = searchValue.toLowerCase();
            filteredData = filteredData.filter(item => {
                return (
                    String(item.donation_id || '').toLowerCase().includes(searchTerm) ||
                    String(item.donor_name || '').toLowerCase().includes(searchTerm) ||
                    String(item.donor_email || '').toLowerCase().includes(searchTerm) ||
                    String(item.shelter_name || '').toLowerCase().includes(searchTerm) ||
                    String(item.host_name || '').toLowerCase().includes(searchTerm)
                );
            });
        }

        if (filterValue && filterValue !== 'all') {
            filteredData = filteredData.filter(item => {
                // Extract the actual status value from the payment_status span element
                const paymentStatus = typeof item.payment_status === 'object'
                    ? item.payment_status.props.children
                    : item.payment_status;
                return paymentStatus === filterValue;
            });
        }


        if (dateValue?.startDate && dateValue?.endDate) {
            filteredData = filteredData.filter(item => {
                if (!item.date_time) return false;
                const itemDate = new Date(item.date_time.split(' ')[0].split('/').reverse().join('-'));
                const startDate = new Date(dateValue.startDate);
                const endDate = new Date(dateValue.endDate);

                // Reset time parts for accurate date comparison
                itemDate.setHours(0, 0, 0, 0);
                startDate.setHours(0, 0, 0, 0);
                endDate.setHours(23, 59, 59, 999);

                return itemDate >= startDate && itemDate <= endDate;
            });
        }

        setData(filteredData);
    };
    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';

        try {
            const date = new Date(dateString);
            if (isNaN(date.getTime())) return 'Invalid Date';

            // Get individual components
            const day = date.getDate();
            const month = date.getMonth() + 1; // getMonth() returns 0-11
            const year = date.getFullYear();

            // Get time in 12-hour format
            let hours = date.getHours();
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const ampm = hours >= 12 ? 'PM' : 'AM';

            // Convert hours to 12-hour format
            hours = hours % 12;
            hours = hours ? hours : 12; // Convert 0 to 12

            // Format the date string
            return `${day}/${month}/${year} ${hours}:${minutes} ${ampm}`;

        } catch (error) {
            console.error('Error formatting date:', error);
            return 'Invalid Date';
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(`${ServerPath}/donation-history/admin`);

                if (response.data.success === 1 && Array.isArray(response.data.data)) {
                    const donationData = response.data.data.map(donation => {
                        // Format the date using the donation_date field
                        const formattedDate = formatDate(donation.donation_date);
                        console.log("Formatted date for donation:", formattedDate);  // Debug log

                        return {
                            ...donation,
                            donation_history_id: donation.donation_history_id,
                            transaction_id: donation.transaction_id,
                            donor_name: donation?.donor_name || 'N/A',
                            donor_email: donation.donor_email,
                            shelter_name: donation.shelter_name,
                            host_name: donation.host_name,
                            donation_amount: `${parseFloat(donation.donation_amount)}`,
                            convenience_fee: `${parseFloat(donation.convenience_fee)}`,
                            net_amount: `${parseFloat(donation.net_amount) - parseFloat(donation.convenience_fee)}`,
                            payment_status: <span
                                className={`badge rounded-pill ${donation?.payment_status === 'SUCCESS' ? 'badge-success' :
                                    donation?.payment_status === 'PENDING' ? 'badge-warning' : 'badge-danger'
                                    }`}
                            >
                                {donation?.payment_status || 'N/A'}
                            </span>,
                            date_time: formattedDate,  // Make sure this matches your column name in tableColumns
                            action: (
                                <div className="action d-flex justify-content-center">
                                    <div className="delete">
                                        <Button
                                            className="btn-square btn btn-danger mx-2"
                                            onClick={(e) => handleDeleteID(donation.donation_history_id, e)}
                                        >
                                            <i className="icon-trash"></i>
                                        </Button>
                                    </div>
                                </div>
                            ),
                        };
                    });

                    setOriginalData(donationData);
                    setData(donationData);
                } else {
                    console.error('Invalid data format received:', response.data);
                    Swal.fire('Error!', 'Invalid data format received', 'error');
                }
            } catch (error) {
                console.error('Error fetching donations:', error);
                Swal.fire('Error!', 'Failed to fetch donation data', 'error');
            }
        };

        fetchData();
    }, []);

    const handleDeleteID = async (donorID, event) => {
        event.preventDefault();
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, cancel!',
            customClass: {
                container: 'swal2-container'
            }
        });

        if (result.isConfirmed) {
            try {
                await _axios.delete(`${ServerPath}/donation/${donorID}`);
                setData(prevData => prevData.filter(data => data.donor_id !== donorID));
                setOriginalData(prevData => prevData.filter(data => data.donor_id !== donorID));
                Swal.fire('Deleted!', 'Donation has been deleted.', 'success');
            } catch (error) {
                console.error('Error deleting donation:', error);
                Swal.fire('Error!', 'There was an error deleting the donation.', 'error');
            }
        }
    };

    const handleRowSelected = useCallback(state => {
        setSelectedRows(state.selectedRows);
    }, []);

    const handleMultiDelete = () => {
        if (window.confirm(`Are you sure you want to delete the selected items?`)) {
            setToggleDelete(!toggleDelete);
            const updatedData = data.filter((item) => !selectedRows.find(row => row.donor_id === item.donor_id));
            setData(updatedData);
            setOriginalData(updatedData);
            setSelectedRows([]);
        }
    };

    return (
        <Fragment>
            <style>{tableStyles}</style>
            <Row>
                <Col sm="12">
                    <Card>
                        <CardBody className='pt-0'>
                            {selectedRows.length > 0 && (
                                <div className={`d-flex align-items-center justify-content-between bg-light-info p-2`}>
                                    <h4 className="text-muted m-0">Delete Selected Records?</h4>
                                    <Button
                                        variant="danger"
                                        onClick={handleMultiDelete}
                                    >
                                        Delete
                                    </Button>
                                </div>
                            )}
                            <DataTable
                                className='data-tables theme-scrollbar pt-4'
                                data={data}
                                columns={tableColumns.map(col => ({
                                    ...col,
                                    selector: typeof col.selector === 'function'
                                        ? (row, index) => col.selector(row, index, currentPage, perPage)
                                        : col.selector,
                                    id: col.name === 'Payment Status' ? 'payment_status' : undefined,
                                }))}
                                fixedHeader
                                fixedHeaderScrollHeight="600px"
                                striped={true}
                                center={true}
                                pagination
                                paginationServer={false}
                                paginationTotalRows={data.length}
                                onChangePage={handlePageChange}
                                onChangeRowsPerPage={handlePerRowsChange}
                                selectableRows
                                onSelectedRowsChange={handleRowSelected}
                                clearSelectedRows={toggleDelete}
                            />
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </Fragment>
    );
};

export default DonationTable;